export default __webpack_public_path__ + "static/app-screen-4-b57b4ba7573ac301a8ea71bb30dae747.png";